import React from 'react';
import { SafeAreaView, View, ImageBackground } from 'react-native';
import { Card, Text, Icon } from 'react-native-elements';
import { StackScreenProps } from '@react-navigation/stack';
import { AppStackParamList } from '../AppStack';
import TouchableWrapper from '../components/TouchableWrapper';
import { colors } from '../utils/constants';
import { verticalScale, scale } from 'react-native-size-matters';

type NavProps = StackScreenProps<AppStackParamList, 'Main'>;

export default function Main({ navigation }: NavProps): JSX.Element {
	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: '#fff' }}>
			<ImageBackground source={require('../../assets/layer.png')} style={{ flex: 1, alignItems: 'center' }}>
				<View style={{ flex: 1, alignItems: 'center', paddingTop: verticalScale(14) }}>
					<Text style={{ fontWeight: '700', fontSize: verticalScale(16), marginBottom: verticalScale(10) }}>
						Pick an option to proceed
					</Text>
					<TouchableWrapper
						onPress={() => {
							navigation.navigate('EnrolleeFeedback');
						}}
						activeOpacity={0.98}
					>
						<Card
							containerStyle={{
								width: scale(200),
								height: verticalScale(200),
								justifyContent: 'center',
								backgroundColor: '#275036',
								borderColor: '#275036',
								borderRadius: 20,
								elevation: 4,
							}}
						>
							<Icon type="feather" name="inbox" size={verticalScale(100)} color="#fff" />
							<Text
								style={{
									textAlign: 'center',
									color: '#fff',
									fontSize: verticalScale(16),
									fontWeight: '700',
									marginTop: verticalScale(20),
								}}
							>
								Enrollee Feedback
							</Text>
						</Card>
					</TouchableWrapper>
					<TouchableWrapper
						onPress={() => {
							navigation.navigate('Login');
						}}
						activeOpacity={0.98}
					>
						<Card
							containerStyle={{
								width: scale(200),
								height: verticalScale(200),
								justifyContent: 'center',
								backgroundColor: '#45a6dd',
								borderColor: '#45a6dd',
								borderRadius: 20,
								elevation: 4,
							}}
						>
							<Icon type="feather" name="user-check" size={verticalScale(100)} color="#fff" />
							<Text
								style={{
									textAlign: 'center',
									color: '#fff',
									fontSize: verticalScale(16),
									fontWeight: '700',
									marginTop: verticalScale(20),
								}}
							>
								Agent Login
							</Text>
						</Card>
					</TouchableWrapper>
				</View>
				<TouchableWrapper
					onPress={() => {
						navigation.navigate('Feedback');
					}}
					activeOpacity={0.98}
					style={{ alignSelf: 'center' }}
				>
					<Card
						containerStyle={{
							width: scale(180),
							justifyContent: 'center',
							backgroundColor: colors.red,
							borderColor: colors.red,
							borderRadius: 20,
							elevation: 4,
							paddingVertical: 4,
							marginBottom: verticalScale(10),
						}}
					>
						<View style={{ flexDirection: 'row', justifyContent: 'center' }}>
							<Icon type="feather" name="help-circle" size={verticalScale(20)} color="#fff" />
							<Text style={{ color: '#fff', fontSize: 14, textAlignVertical: 'center' }}>Enquiries</Text>
						</View>
					</Card>
				</TouchableWrapper>
			</ImageBackground>
		</SafeAreaView>
	);
}
